import {createSelector} from '@ngrx/store';
import {AppState} from '../app-state';

export const selectCurrentSkedState = (state: AppState) => state.currentSked;

export const selectCurrentSked = createSelector(selectCurrentSkedState, state => state.currentSked);

export const selectSkedProjects = createSelector(selectCurrentSkedState, state => state.currentSkedProjectsMap);

export const selectCurrentSkedDetailTask = createSelector(selectCurrentSkedState, state => state.task);

export const selectUpdatedTask = createSelector(selectCurrentSkedState, state => state.updatedTask);

export const selectCurrentSkedValueChosenMap = createSelector(
  selectCurrentSkedState,
  state => state.metricUpdateValueChosenMap
);

export const selectMetricFormStateMap = createSelector(selectCurrentSkedState, state => state.metricFormStateMap);

export const selectMetricFormState = (taskId: string, subtaskId: string) =>
  createSelector(selectMetricFormStateMap, formStateMap => formStateMap[taskId]?.[subtaskId]);

export const selectCurrentSkedContext = createSelector(selectCurrentSkedState, state => state.skedContext);

export const selectChallengeMap = createSelector(selectCurrentSkedState, state => state.challengeMap);

export const selectChallengeDaysMap = createSelector(selectCurrentSkedState, state => state.challengeDaysMap);

export const selectChallengeCyclesMap = createSelector(selectCurrentSkedState, state => state.challengeCyclesMap);

export const selectChallengeById = (challengeId: string) =>
  createSelector(selectChallengeMap, challengeMap => challengeMap[challengeId] ?? null);

export const selectChallengeDaysById = (challengeId: string) =>
  createSelector(selectChallengeDaysMap, daysMap => daysMap[challengeId] ?? null);

export const selectChallengeCyclesById = (challengeId: string) =>
  createSelector(selectChallengeCyclesMap, cyclesMap => cyclesMap[challengeId] ?? null);

export const selectChallengeCycleByStartDate = (projectId: string, startDate: string) =>
  createSelector(selectChallengeCyclesMap, cyclesMap => cyclesMap[projectId]?.[startDate] ?? null);

export const selectChartDetailMap = createSelector(selectCurrentSkedState, state => state.chartDetailMap);

export const selectChartDetailLoadingMap = createSelector(selectCurrentSkedState, state => state.chartDetailLoadingMap);

export const selectChartDetailFor = (dateKey: string, metricId: string) =>
  createSelector(selectChartDetailMap, map => map[dateKey]?.[metricId] ?? null);

export const selectChartDetailLoadingFor = (dateKey: string, metricId: string) =>
  createSelector(selectChartDetailLoadingMap, map => !!map[dateKey]?.[metricId]);
